import { useFlags } from 'launchdarkly-react-client-sdk';

const useFeatureFlags = () => {
	// get flags
	const flags = useFlags();

	// manipulate flags
	flags.recorderVersion = flags.recorderVersion ? Math.max(4.9, parseFloat(flags.recorderVersion)) : 4.9;

	// ...
	// flags.shorts = false;
	// return flags
	// flags.webRecorderNotifications = {};
	return flags;
};

export default useFeatureFlags;
